import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit'
import { getRiskMitigationHistoryData } from './history.async'

const initialState = {
  riskMitigationHistoryLoader: false,
  riskMitigationHistoryData: {
    timeline: [],
  },
}

const RiskMitigationHistoryReducer = createSlice({
  name: 'RiskMitigationHistoryReducer',
  initialState,
  reducers: {
    emptyRiskMitigationHistoryReducer: (state) => {},
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getRiskMitigationHistoryData.pending), (state) => {
      state.riskMitigationHistoryLoader = true
    })
    builder.addMatcher(isAnyOf(getRiskMitigationHistoryData.fulfilled), (state, action) => {
      state.riskMitigationHistoryLoader = false
      state.riskMitigationHistoryData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getRiskMitigationHistoryData.rejected), (state) => {
      state.riskMitigationHistoryLoader = false
    })
  },
})

export const { emptyRiskMitigationHistoryReducer } = RiskMitigationHistoryReducer.actions
export default RiskMitigationHistoryReducer.reducer
